import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

export const MaintenanceProgramAuditAction = z.enum([
  'change_due_month',
  'change_interval',
  'complete_past_quarter',
  'delete_task',
  // MCP-648: program items added/removed as a side effect of a survey
  // modification through `modifySurvey`. One entry per call — the full set
  // of survey-field changes and item add/remove diffs lives in
  // `before` / `after`.
  'resurvey',
])
export type MaintenanceProgramAuditAction = z.infer<
  typeof MaintenanceProgramAuditAction
>

export const MaintenanceProgramAuditLog = z.object({
  companyId: z.string(),
  siteId: z.string(),
  unitId: z.string(),
  programId: z.string(),
  // Calendar year of the maintenance program at the time of the change.
  // Optional so older entries (written before this field existed) still parse.
  programYear: z.number().int().optional(),
  itemId: z.string(),

  taskCodeRef: z.string().nullable().optional(),
  taskTitle: z.string().optional(),

  userId: z.string(),

  action: MaintenanceProgramAuditAction,
  before: z.record(z.string(), z.unknown()),
  after: z.record(z.string(), z.unknown()),
  reason: z.string(),

  // MCP-648: set on `resurvey` entries to link the audit trail back to the
  // exact survey doc that triggered the program change. The field-level
  // diff itself lives in `before.surveyFields` / `after.surveyFields`.
  // Optional so existing entries from other actions still parse.
  surveyId: z.string().optional(),

  timestamp: FirestoreTimestamp,
})
export type MaintenanceProgramAuditLog = z.infer<
  typeof MaintenanceProgramAuditLog
>
